import axios from "axios";
import { apiBaseURL, apiAuthHeader } from "./apiEnv";

export default (config) => {
  return axios.create({
    baseURL: apiBaseURL,
    withCredentials: false,
    timeout: 30000,
    responseType: "blob",
    headers: {
      ...apiAuthHeader,
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": "GET, POST, OPTIONS, PUT, DELETE",
      "Access-Control-Allow-Headers": "Origin, Authorization",
      store: config.store,
      isu: config.isu,
      platform: 1,
      version: import.meta.env.VITE_VERSION_PROJECT,
    },
  });
};
